import { EcommerceCartItem } from '@jbhi-fi/utils/src/ga4Tracking/types';
import { tryParseJson } from '@jbhi-fi/utils/src/JSON/tryParseJson';
import { ServiceOffering } from '@jbhi-fi/apis/src/services/types';
import { getCartItemChangeAlert } from './getCartItemChangeAlert';
import { JbCartItem } from '@jbhi-fi/apis/src/shopify/types/JbCart';

const normalize = (value: string) => (value && value !== '(not set)' ? value : undefined);

export const transformCartItemForTracking = (item: JbCartItem): EcommerceCartItem | undefined => {
  const gtmProduct = item.onlineProduct;
  const productProperties = gtmProduct?.ProductTags?.GoogleTagManager;

  const categories = productProperties?.Category?.split('/') || [];

  const brand =
    normalize(categories[3] || categories[2] || categories[1] || categories[0] || item?.vendor) ||
    productProperties?.Name;

  const productDisplay = gtmProduct?.Display;
  const name = normalize(productDisplay?.OnlineDescription || '') || item?.product_title || '';
  const reviewCount = productDisplay?.NumberOfProductReviews || 0;
  const reviewScore = productDisplay?.AverageProductReviewRating || 0;
  const saveAmount = gtmProduct?.SaveAmount || 0;

  return {
    discount: saveAmount,
    item_bestseller_flag: gtmProduct?.ProductTags?.AllCalculatedProductTags?.join(', ') || '(none)',
    item_brand: brand,
    item_category: categories[0] || item?.product_type,
    item_category2: categories[1],
    item_category3: categories[2],
    item_category4: categories[3],
    item_id: item.sku,
    item_list_name: item.properties?._itemListName,
    item_list_slot: item.properties?._itemListSlot,
    item_list_service_config: item.properties?._itemListServiceConfig,
    item_name: name,
    item_review_count: reviewCount,
    item_review_score: reviewScore,
    item_variant: '(unavailable)',
    price: Number((item.line_price / 100).toFixed(2)),
    quantity: item.quantity,
    marketplace_product: item.properties?._marketplaceSellerId ? 'Y' : 'N',
    marketplace_seller_type: item.properties?._marketplaceSellerId ? '3P' : 'N/A',
    marketplace_seller_name: item.properties?._marketplaceSeller || 'N/A',
  };
};

export const transformCartItemForMessages = (item: Record<string, any>): string | undefined => {
  const isDigitalDelivery =
    item.properties._availabilityFulfilment === 'Digital' || item.properties.Delivery === 'Digital';
  const isPreOrder = item.properties._availabilityCanPreOrder === 'true';
  const { variant } = getCartItemChangeAlert(item);
  const messageTrack = [];
  if (isDigitalDelivery) messageTrack?.push('Digital delivery');
  if (isPreOrder) messageTrack.push('Pre-order');
  if (variant === 'price') messageTrack.push('Price increase');
  if (variant === 'noLongerAvailable') messageTrack.push('Item no longer available');
  if (!item.isValidService) messageTrack.push('Service no longer available');
  return messageTrack?.length ? messageTrack?.join(', ') : undefined;
};
